import { authRoles } from 'app/auth';
import PetrosimModelEditForm from './editform/PetrosimModelEditForm';

export default [
	{
		path: '/model-petrosim/edit/:id/:driverName?',
		component: PetrosimModelEditForm,
		auth: authRoles.model
	}
];
